/* eslint-disable max-lines-per-function */
import React from 'react';
import { Table } from 'semantic-ui-react';
import range from 'lodash/range';
import {
    renderPrice, Header, Cell, EmptyCell, Title, filterObject
} from '../components';
import usePrint from '+/hooks/usePrint';
import Dimmer from '+/Dimmer';
import { PrintDate } from '../../../shared/components/PrintDate';

const styles = {
    root: {
        padding: '15px',
        fontWeight: 'bold'
    },
    green: {
        backgroundColor: '#CCFFCC'
    },
    yellow: {
        backgroundColor: 'yellow',
        padding: 0
    }
};

// const totalPrice

const MiamiBayMatrix = props => {

    const { data, isLoading, matrixType } = props;

    const { ref, Trigger } = usePrint();

    if (!data || isLoading) return <Dimmer message='Fetching matrix, this can take up to 60 seconds' />;

    const countTotal = units => units.reduce((acc, cur) => acc + renderPrice(data[cur], matrixType, true), 0).toLocaleString('en-US');

    return (
        <div ref={ref} style={styles.root} className='print landscape'>
            <div>
                <Trigger />
            </div>
            <Title data={Object.values(filterObject(data, '601-'))} title='Miami Bay Club Apartments'/>
            <PrintDate isForPDF={false}/>
            <div className='print-font-small'>

                <Table celled compact textAlign='center'>
                    <Table.Header>
                        <Table.Row>
                            <Header colSpan='100' content='601 NE 39th St - Building A' />
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell colSpan='100' content='North View' />
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell />
                            <Header colSpan='2' content='C' />
                            <Header colSpan='2' content='A6' />
                            <Header colSpan='2' content='A6' />
                            <Header colSpan='2' content='A3' />
                            <Header colSpan='2' content='A3' />
                            <Header colSpan='2' content='A6' />
                            <Header colSpan='2' content='A6' />
                            <Header colSpan='2' content='C' />
                        </Table.Row>

                        <Table.Row>
                            <Table.HeaderCell />
                            <Header colSpan='2' content='2B/2B' />
                            <Header colSpan='2' content='1B/1B' />
                            <Header colSpan='2' content='1B/1B' />
                            <Header colSpan='2' content='1B/1B' />
                            <Header colSpan='2' content='1B/1B' />
                            <Header colSpan='2' content='1B/1B' />
                            <Header colSpan='2' content='1B/1B' />
                            <Header colSpan='2' content='2B/2B' />
                        </Table.Row>

                        <Table.Row>
                            <Table.HeaderCell />
                            <Header colSpan='2' content='1070 sq ft' />
                            <Header colSpan='2' content='810 sq ft' />
                            <Header colSpan='2' content='810 sq ft' />
                            <Header colSpan='2' content='810 sq ft' />
                            <Header colSpan='2' content='810 sq ft' />
                            <Header colSpan='2' content='810 sq ft' />
                            <Header colSpan='2' content='810 sq ft' />
                            <Header colSpan='2' content='1070 sq ft' />
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {range(5, 0, -1)
                            .map(n => n.toLocaleString('en-US', {
                                minimumIntegerDigits: 1,
                                useGrouping: false
                            }))
                            .map((floor, i) => (
                                <Table.Row key={`floor-${floor}`}>
                                    <Table.Cell content={`${floor}FL`} />
                                    {['20', '18', '16', '14', '02', '04', '06', '08'].map(unit_num => (
                                        <Cell
                                            key={`${floor}${unit_num}`}
                                            unit={`${floor}${unit_num}`}
                                            price={renderPrice(data[`601-${floor}${unit_num}`], matrixType)}
                                            status={data[`601-${floor}${unit_num}`].status}
                                        />
                                    ))}
                                </Table.Row>
                            ))}

                        <Table.Row>
                            <Table.Cell content='Total' />
                            <Table.Cell />
                            <Table.Cell style={styles.yellow}>
                            ${countTotal(['601-520', '601-420', '601-320', '601-220', '601-120'])}
                            </Table.Cell>
                            <Table.Cell />
                            <Table.Cell style={styles.yellow}>
                            ${countTotal(['601-518', '601-418', '601-318', '601-218', '601-118'])}
                            </Table.Cell>
                            <Table.Cell />
                            <Table.Cell style={styles.yellow}>
                            ${countTotal(['601-516', '601-416', '601-316', '601-216', '601-116'])}
                            </Table.Cell>
                            <Table.Cell />
                            <Table.Cell style={styles.yellow}>
                            ${countTotal(['601-514', '601-414', '601-314', '601-214', '601-114'])}
                            </Table.Cell>
                            <Table.Cell />
                            <Table.Cell style={styles.yellow}>
                            ${countTotal(['601-502', '601-402', '601-302', '601-202', '601-102'])}
                            </Table.Cell>
                            <Table.Cell />
                            <Table.Cell style={styles.yellow}>
                            ${countTotal(['601-504', '601-404', '601-304', '601-204', '601-104'])}
                            </Table.Cell>
                            <Table.Cell />
                            <Table.Cell style={styles.yellow}>
                            ${countTotal(['601-506', '601-406', '601-306', '601-206', '601-106'])}
                            </Table.Cell>
                            <Table.Cell />
                            <Table.Cell style={styles.yellow}>
                            ${countTotal(['601-508', '601-408', '601-308', '601-208', '601-108'])}
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>

                <Table celled compact textAlign='center'>
                    <Table.Header>
                        <Table.Row>
                            <Header colSpan='100' content='601 NE 39th St - Building A' />
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell colSpan='100' content='South View' />
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell />
                            <Header colSpan='2' content='A6' />
                            <Header colSpan='2' content='A6' />
                            <Header colSpan='2' content='A6' />
                            <Header colSpan='2' content='A6' />
                            <Header colSpan='2' content='A1' />
                            <Header colSpan='2' content='C' />
                            <Header colSpan='2' content='A6' />
                            <Header colSpan='2' content='A5' />
                            <Header colSpan='2' content='A4' />
                            <Header colSpan='2' content='A4' />
                        </Table.Row>

                        <Table.Row>
                            <Table.HeaderCell />
                            <Header colSpan='2' content='1B/1B' />
                            <Header colSpan='2' content='1B/1B' />
                            <Header colSpan='2' content='1B/1B' />
                            <Header colSpan='2' content='1B/1B' />
                            <Header colSpan='2' content='1B/1B' />
                            <Header colSpan='2' content='2B/2B' />
                            <Header colSpan='2' content='1B/1B' />
                            <Header colSpan='2' content='1B/1B' />
                            <Header colSpan='2' content='1B/1B' />
                            <Header colSpan='2' content='1B/1B' />
                        </Table.Row>

                        <Table.Row>
                            <Table.HeaderCell />
                            <Header colSpan='2' content='810 sq ft' />
                            <Header colSpan='2' content='810 sq ft' />
                            <Header colSpan='2' content='810 sq ft' />
                            <Header colSpan='2' content='810 sq ft' />
                            <Header colSpan='2' content='810 sq ft' />
                            <Header colSpan='2' content='1070 sq ft' />
                            <Header colSpan='2' content='810 sq ft' />
                            <Header colSpan='2' content='810 sq ft' />
                            <Header colSpan='2' content='810 sq ft' />
                            <Header colSpan='2' content='810 sq ft' />
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {range(5, 0, -1)
                            .map(n => n.toLocaleString('en-US', {
                                minimumIntegerDigits: 1,
                                useGrouping: false
                            }))
                            .map((floor, i) => (
                                <Table.Row key={`floor-${floor}`}>
                                    <Table.Cell content={`${floor}FL`} />
                                    {['22', '21', '19', '17', '15', '01', '03', '05', '07', '09'].map(unit_num => (
                                        <Cell
                                            key={`${floor}${unit_num}`}
                                            unit={`${floor}${unit_num}`}
                                            price={renderPrice(data[`601-${floor}${unit_num}`], matrixType)}
                                            status={data[`601-${floor}${unit_num}`].status}
                                        />
                                    ))}
                                </Table.Row>
                            ))}

                        <Table.Row>
                            <Table.Cell content='Total' />
                            <Table.Cell />
                            <Table.Cell style={styles.yellow}>
                            ${countTotal(['601-522', '601-422', '601-322', '601-222', '601-122'])}
                            </Table.Cell>
                            <Table.Cell />
                            <Table.Cell style={styles.yellow}>
                            ${countTotal(['601-521', '601-421', '601-321', '601-221', '601-121'])}
                            </Table.Cell>
                            <Table.Cell />
                            <Table.Cell style={styles.yellow}>
                            ${countTotal(['601-519', '601-419', '601-319', '601-219', '601-119'])}
                            </Table.Cell>
                            <Table.Cell />
                            <Table.Cell style={styles.yellow}>
                            ${countTotal(['601-517', '601-417', '601-317', '601-217', '601-117'])}
                            </Table.Cell>
                            <Table.Cell />
                            <Table.Cell style={styles.yellow}>
                            ${countTotal(['601-515', '601-415', '601-315', '601-215', '601-115'])}
                            </Table.Cell>
                            <Table.Cell />
                            <Table.Cell style={styles.yellow}>
                            ${countTotal(['601-501', '601-401', '601-301', '601-201', '601-101'])}
                            </Table.Cell>
                            <Table.Cell />
                            <Table.Cell style={styles.yellow}>
                            ${countTotal(['601-503', '601-403', '601-303', '601-203', '601-103'])}
                            </Table.Cell>
                            <Table.Cell />
                            <Table.Cell style={styles.yellow}>
                            ${countTotal(['601-505', '601-405', '601-305', '601-205', '601-105'])}
                            </Table.Cell>
                            <Table.Cell />
                            <Table.Cell style={styles.yellow}>
                            ${countTotal(['601-507', '601-407', '601-307', '601-207', '601-107'])}
                            </Table.Cell>
                            <Table.Cell />
                            <Table.Cell style={styles.yellow}>
                            ${countTotal(['601-509', '601-409', '601-309', '601-209', '601-109'])}
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>

                <Table celled compact textAlign='center'>
                    <Table.Header>
                        <Table.Row>
                            <Header colSpan='100' content='601 NE 39th St - Building A' />
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell colSpan='9' content='West View' />
                            <Table.HeaderCell colSpan='10' content='East View' />
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell />
                            <Header colSpan='2' content='A2' />
                            <Header colSpan='2' content='C3' />
                            <Header colSpan='2' content='A2' />
                            <Header colSpan='2' content='B2' />
                            <Header colSpan='2' content='D' />
                            <Header colSpan='2' content='B1' />
                            <Header colSpan='2' content='E' />
                            <Header colSpan='2' content='B3' />
                            <Header colSpan='2' content='H' />
                        </Table.Row>

                        <Table.Row>
                            <Table.HeaderCell />
                            <Header colSpan='2' content='1B/1B' />
                            <Header colSpan='2' content='2B/2B' />
                            <Header colSpan='2' content='1B/1B' />
                            <Header colSpan='2' content='2B/2B' />
                            <Header colSpan='2' content='3B/2B' />
                            <Header colSpan='2' content='2B/2B' />
                            <Header colSpan='2' content='3B/2B' />
                            <Header colSpan='2' content='2B/2B' />
                            <Header colSpan='2' content='5B/4B' />
                        </Table.Row>

                        <Table.Row>
                            <Table.HeaderCell />
                            <Header colSpan='2' content='680 sq ft' />
                            <Header colSpan='2' content='1052 sq ft' />
                            <Header colSpan='2' content='680 sq ft' />
                            <Header colSpan='2' content='970 sq ft' />
                            <Header colSpan='2' content='1230 sq ft' />
                            <Header colSpan='2' content='970 sq ft' />
                            <Header colSpan='2' content='1380 sq ft' />
                            <Header colSpan='2' content='1970 sq ft' />
                            <Header colSpan='2' />
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        <Table.Row>
                            <Table.Cell content='5FL' />
                            <Cell unit='525' price={renderPrice(data['601-525'], matrixType)} status={data['601-525'].status}/>
                            <EmptyCell />
                            <Cell unit='524' price={renderPrice(data['601-524'], matrixType)} status={data['601-524'].status}/>
                            <Cell unit='523' price={renderPrice(data['601-523'], matrixType)} status={data['601-523'].status}/>
                            <Cell unit='526' price={renderPrice(data['601-526'], matrixType)} status={data['601-526'].status}/>
                            <Cell unit='512' price={renderPrice(data['601-512'], matrixType)} status={data['601-512'].status}/>
                            <EmptyCell count={3} />
                        </Table.Row>

                        <Table.Row>
                            <Table.Cell content='4FL' />
                            <Cell unit='425' price={renderPrice(data['601-425'], matrixType)} status={data['601-425'].status}/>
                            <EmptyCell />
                            <Cell unit='424' price={renderPrice(data['601-424'], matrixType)} status={data['601-424'].status}/>
                            <Cell unit='423' price={renderPrice(data['601-423'], matrixType)} status={data['601-423'].status}/>
                            <Cell unit='426' price={renderPrice(data['601-426'], matrixType)} status={data['601-426'].status}/>
                            <Cell unit='412' price={renderPrice(data['601-412'], matrixType)} status={data['601-412'].status}/>
                            <Cell unit='411' price={renderPrice(data['601-411'], matrixType)} status={data['601-411'].status}/>
                            <Cell unit='410' price={renderPrice(data['601-410'], matrixType)} status={data['601-410'].status}/>
                            <EmptyCell />
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell content='3FL' />
                            <Cell unit='325' price={renderPrice(data['601-325'], matrixType)} status={data['601-325'].status}/>
                            <EmptyCell />
                            <Cell unit='324' price={renderPrice(data['601-324'], matrixType)} status={data['601-324'].status}/>
                            <Cell unit='323' price={renderPrice(data['601-323'], matrixType)} status={data['601-323'].status}/>
                            <Cell unit='326' price={renderPrice(data['601-326'], matrixType)} status={data['601-326'].status}/>
                            <Cell unit='312' price={renderPrice(data['601-312'], matrixType)} status={data['601-312'].status}/>
                            <Cell unit='311' price={renderPrice(data['601-311'], matrixType)} status={data['601-311'].status}/>
                            <Cell unit='310' price={renderPrice(data['601-310'], matrixType)} status={data['601-310'].status}/>
                            <EmptyCell />
                        </Table.Row>

                        <Table.Row>
                            <Table.Cell content='2FL' />
                            <Cell unit='225' price={renderPrice(data['601-225'], matrixType)} status={data['601-225'].status}/>
                            <EmptyCell />
                            <Cell unit='224' price={renderPrice(data['601-224'], matrixType)} status={data['601-224'].status}/>
                            <Cell unit='223' price={renderPrice(data['601-223'], matrixType)} status={data['601-223'].status}/>
                            <Cell unit='226' price={renderPrice(data['601-226'], matrixType)} status={data['601-226'].status}/>
                            <Cell unit='212' price={renderPrice(data['601-212'], matrixType)} status={data['601-212'].status}/>
                            <Cell unit='211' price={renderPrice(data['601-211'], matrixType)} status={data['601-211'].status}/>
                            <Cell unit='210' price={renderPrice(data['601-210'], matrixType)} status={data['601-210'].status}/>
                            <EmptyCell />
                        </Table.Row>

                        <Table.Row>
                            <Table.Cell content='1FL' />
                            <EmptyCell />
                            <Cell unit='124' price={renderPrice(data['601-124'], matrixType)} status={data['601-124'].status}/>
                            <EmptyCell />
                            <Cell unit='123' price={renderPrice(data['601-123'], matrixType)} status={data['601-123'].status}/>
                            <Cell unit='126' price={renderPrice(data['601-126'], matrixType)} status={data['601-126'].status}/>
                            <Cell unit='112' price={renderPrice(data['601-112'], matrixType)} status={data['601-112'].status}/>
                            <Cell unit='111' price={renderPrice(data['601-111'], matrixType)} status={data['601-111'].status}/>
                            <Cell unit='110' price={renderPrice(data['601-110'], matrixType)} status={data['601-110'].status}/>
                            <EmptyCell />
                        </Table.Row>

                        <Table.Row>
                            <Table.Cell content='Total' />
                            <Table.Cell />
                            <Table.Cell style={styles.yellow}>${countTotal(['601-525', '601-425', '601-325', '601-225'])}</Table.Cell>
                            <Table.Cell />
                            <Table.Cell style={styles.yellow}>${countTotal(['601-124'])}</Table.Cell>
                            <Table.Cell />
                            <Table.Cell style={styles.yellow}>${countTotal(['601-524', '601-424', '601-324', '601-224'])}</Table.Cell>
                            <Table.Cell />
                            <Table.Cell style={styles.yellow}>
                            ${countTotal(['601-523', '601-423', '601-323', '601-223', '601-123'])}
                            </Table.Cell>
                            <Table.Cell />
                            <Table.Cell style={styles.yellow}>
                            ${countTotal(['601-526', '601-426', '601-326', '601-226', '601-126'])}
                            </Table.Cell>
                            <Table.Cell />
                            <Table.Cell style={styles.yellow}>
                            ${countTotal(['601-512', '601-412', '601-312', '601-212', '601-112'])}
                            </Table.Cell>
                            <Table.Cell />
                            <Table.Cell style={styles.yellow}>${countTotal(['601-411', '601-311', '601-211', '601-111'])}</Table.Cell>
                            <Table.Cell />
                            <Table.Cell style={styles.yellow}>${countTotal(['601-410', '601-310', '601-210', '601-110'])}</Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>
            </div>

            <div className='pagebreak' />
            <div className='printspace' />
            <Title data={Object.values(filterObject(data, '445-'))} title='Miami Bay Club Apartments'/>
            <PrintDate isForPDF={false}/>
            <Table celled compact textAlign='center'>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell colSpan='100' content='445 NE 39TH ST - Building B' />
                    </Table.Row>
                    <Table.Row>
                        <Table.HeaderCell colSpan='6' content='North View' />
                        <Table.HeaderCell colSpan='8' content='South View' />
                        <Table.HeaderCell colSpan='4' content='East View' />
                    </Table.Row>
                    <Table.Row>
                        <Table.HeaderCell />
                        <Header colSpan='2' content='A7' />
                        <Header colSpan='2' content='B7' />
                        <Header colSpan='2' content='A7' />
                        <Header colSpan='2' content='F (No Den)' />
                        <Header colSpan='2' content='F' />
                        <Header colSpan='2' content='C1' />
                        <Header colSpan='2' content='C2' />
                        <Header colSpan='2' content='B6' />
                        <Header colSpan='2' content='B6' />
                    </Table.Row>

                    <Table.Row>
                        <Table.HeaderCell />
                        <Header colSpan='2' content='1B/1B' />
                        <Header colSpan='2' content='2B/1B' />
                        <Header colSpan='2' content='1B/1B' />
                        <Header colSpan='2' content='1B/1B' />
                        <Header colSpan='2' content='1B/1B + Den' />
                        <Header colSpan='2' content='2B/2B' />
                        <Header colSpan='2' content='2B/2B' />
                        <Header colSpan='2' content='2B/2B' />
                        <Header colSpan='2' content='2B/2B' />
                    </Table.Row>

                    <Table.Row>
                        <Table.HeaderCell />
                        <Header colSpan='2' content='835 sq ft' />
                        <Header colSpan='2' content='965 sq ft' />
                        <Header colSpan='2' content='835 sq ft' />
                        <Header colSpan='2' content='640 sq ft' />
                        <Header colSpan='2' content='760 sq ft' />
                        <Header colSpan='2' content='1130 sq ft' />
                        <Header colSpan='2' content='1130 sq ft' />
                        <Header colSpan='2' content='950 sq ft' />
                        <Header colSpan='2' content='950 sq ft' />
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    <Table.Row>
                        <Table.Cell content='5FL' />
                        <EmptyCell />
                        <Cell unit='506' price={renderPrice(data['445-506'], matrixType)} status={data['445-506'].status}/>
                        <Cell unit='502' price={renderPrice(data['445-502'], matrixType)} status={data['445-502'].status}/>
                        <EmptyCell />
                        <Cell unit='507' price={renderPrice(data['445-507'], matrixType)} status={data['445-507'].status}/>
                        <Cell unit='505' price={renderPrice(data['445-505'], matrixType)} status={data['445-505'].status}/>
                        <Cell unit='501' price={renderPrice(data['445-501'], matrixType)} status={data['445-501'].status}/>
                        <Cell unit='504' price={renderPrice(data['445-504'], matrixType)} status={data['445-504'].status}/>
                        <Cell unit='503' price={renderPrice(data['445-503'], matrixType)} status={data['445-503'].status}/>
                    </Table.Row>

                    <Table.Row>
                        <Table.Cell content='4FL' />
                        <EmptyCell />
                        <Cell unit='406' price={renderPrice(data['445-406'], matrixType)} status={data['445-406'].status}/>
                        <Cell unit='402' price={renderPrice(data['445-402'], matrixType)} status={data['445-402'].status}/>
                        <EmptyCell />
                        <Cell unit='407' price={renderPrice(data['445-407'], matrixType)} status={data['445-407'].status}/>
                        <Cell unit='405' price={renderPrice(data['445-405'], matrixType)} status={data['445-405'].status}/>
                        <Cell unit='401' price={renderPrice(data['445-401'], matrixType)} status={data['445-401'].status}/>
                        <Cell unit='404' price={renderPrice(data['445-404'], matrixType)} status={data['445-404'].status}/>
                        <Cell unit='403' price={renderPrice(data['445-403'], matrixType)} status={data['445-403'].status}/>
                    </Table.Row>

                    <Table.Row>
                        <Table.Cell content='3FL' />
                        <EmptyCell />
                        <Cell unit='306' price={renderPrice(data['445-306'], matrixType)} status={data['445-306'].status}/>
                        <Cell unit='302' price={renderPrice(data['445-302'], matrixType)} status={data['445-302'].status}/>
                        <EmptyCell />
                        <Cell unit='307' price={renderPrice(data['445-307'], matrixType)} status={data['445-307'].status}/>
                        <Cell unit='305' price={renderPrice(data['445-305'], matrixType)} status={data['445-305'].status}/>
                        <Cell unit='301' price={renderPrice(data['445-301'], matrixType)} status={data['445-301'].status}/>
                        <Cell unit='304' price={renderPrice(data['445-304'], matrixType)} status={data['445-304'].status}/>
                        <Cell unit='303' price={renderPrice(data['445-303'], matrixType)} status={data['445-303'].status}/>
                    </Table.Row>

                    <Table.Row>
                        <Table.Cell content='2FL' />
                        <EmptyCell />
                        <Cell unit='206' price={renderPrice(data['445-206'], matrixType)} status={data['445-206'].status}/>
                        <Cell unit='202' price={renderPrice(data['445-202'], matrixType)} status={data['445-202'].status}/>
                        <EmptyCell />
                        <Cell unit='207' price={renderPrice(data['445-207'], matrixType)} status={data['445-207'].status}/>
                        <Cell unit='205' price={renderPrice(data['445-205'], matrixType)} status={data['445-205'].status}/>
                        <Cell unit='201' price={renderPrice(data['445-201'], matrixType)} status={data['445-201'].status}/>
                        <Cell unit='204' price={renderPrice(data['445-204'], matrixType)} status={data['445-204'].status}/>
                        <Cell unit='203' price={renderPrice(data['445-203'], matrixType)} status={data['445-203'].status}/>
                    </Table.Row>

                    <Table.Row>
                        <Table.Cell content='1FL' />
                        <Cell unit='106' price={renderPrice(data['445-106'], matrixType)} status={data['445-106'].status}/>
                        <EmptyCell />
                        <Cell unit='102' price={renderPrice(data['445-102'], matrixType)} status={data['445-102'].status}/>
                        <Cell unit='107' price={renderPrice(data['445-107'], matrixType)} status={data['445-107'].status}/>
                        <EmptyCell />
                        <Cell unit='105' price={renderPrice(data['445-105'], matrixType)} status={data['445-105'].status}/>
                        <Cell unit='101' price={renderPrice(data['445-101'], matrixType)} status={data['445-101'].status}/>
                        <Cell unit='104' price={renderPrice(data['445-104'], matrixType)} status={data['445-104'].status}/>
                        <Cell unit='103' price={renderPrice(data['445-103'], matrixType)} status={data['445-103'].status}/>
                    </Table.Row>

                    <Table.Row>
                        <Table.Cell content='Total' />
                        <Table.Cell />
                        <Table.Cell style={styles.yellow}>${countTotal(['445-106'])}</Table.Cell>
                        <Table.Cell />
                        <Table.Cell style={styles.yellow}>${countTotal(['445-506', '445-406', '445-306', '445-206'])}</Table.Cell>
                        <Table.Cell />
                        <Table.Cell style={styles.yellow}>
                            ${countTotal(['445-502', '445-402', '445-302', '445-202', '445-102'])}
                        </Table.Cell>
                        <Table.Cell />
                        <Table.Cell style={styles.yellow}>${countTotal(['445-107'])}</Table.Cell>
                        <Table.Cell />
                        <Table.Cell style={styles.yellow}>${countTotal(['445-507', '445-407', '445-307', '445-207'])}</Table.Cell>
                        <Table.Cell />
                        <Table.Cell style={styles.yellow}>
                            ${countTotal(['445-505', '445-405', '445-305', '445-205', '445-105'])}
                        </Table.Cell>
                        <Table.Cell />
                        <Table.Cell style={styles.yellow}>
                            ${countTotal(['445-501', '445-401', '445-301', '445-201', '445-101'])}
                        </Table.Cell>
                        <Table.Cell />
                        <Table.Cell style={styles.yellow}>
                            ${countTotal(['445-504', '445-404', '445-304', '445-204', '445-104'])}
                        </Table.Cell>
                        <Table.Cell />
                        <Table.Cell style={styles.yellow}>
                            ${countTotal(['445-503', '445-403', '445-303', '445-203', '445-103'])}
                        </Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
            <Table celled compact textAlign='center'>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell colSpan='100' content='445 NE 39TH ST - Building C' />
                    </Table.Row>
                    <Table.Row>
                        <Table.HeaderCell colSpan='100' content='East View' />
                    </Table.Row>
                    <Table.Row>
                        <Table.HeaderCell />
                        <Header colSpan='2' content='B5' />
                        <Header colSpan='2' content='B4' />
                        <Header colSpan='2' content='B4' />
                        <Header colSpan='2' content='G' />
                        <Header colSpan='2' content='B4' />
                        <Header colSpan='2' content='G' />
                        <Header colSpan='2' content='B4' />
                        <Header colSpan='2' content='B5' />
                    </Table.Row>

                    <Table.Row>
                        <Table.HeaderCell />
                        <Header colSpan='2' content='2B/2B' />
                        <Header colSpan='2' content='2B/2B' />
                        <Header colSpan='2' content='2B/2B' />
                        <Header colSpan='2' content='3B/2B' />
                        <Header colSpan='2' content='2B/2B' />
                        <Header colSpan='2' content='3B/2B' />
                        <Header colSpan='2' content='2B/2B' />
                        <Header colSpan='2' content='2B/2B' />
                    </Table.Row>

                    <Table.Row>
                        <Table.HeaderCell />
                        <Header colSpan='2' content='1260 sq ft' />
                        <Header colSpan='2' content='975 sq ft' />
                        <Header colSpan='2' content='975 sq ft' />
                        <Header colSpan='2' content='1185 sq ft' />
                        <Header colSpan='2' content='975 sq ft' />
                        <Header colSpan='2' content='1185 sq ft' />
                        <Header colSpan='2' content='975 sq ft' />
                        <Header colSpan='2' content='1260 sq ft' />
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    <Table.Row>
                        <Table.Cell content='3FL' />
                        <Cell unit='301' price={renderPrice(data['531-301'], matrixType)} status={data['531-301'].status}/>
                        <Cell unit='302' price={renderPrice(data['531-302'], matrixType)} status={data['531-302'].status}/>
                        <EmptyCell />
                        <Cell unit='303' price={renderPrice(data['531-303'], matrixType)} status={data['531-303'].status}/>
                        <EmptyCell />
                        <Cell unit='304' price={renderPrice(data['531-304'], matrixType)} status={data['531-304'].status}/>
                        <Cell unit='305' price={renderPrice(data['531-305'], matrixType)} status={data['531-305'].status}/>
                        <Cell unit='306' price={renderPrice(data['531-306'], matrixType)} status={data['531-306'].status}/>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell content='2FL' />
                        <Cell unit='201' price={renderPrice(data['531-201'], matrixType)} status={data['531-201'].status}/>
                        <Cell unit='202' price={renderPrice(data['531-202'], matrixType)} status={data['531-202'].status}/>
                        <EmptyCell />
                        <Cell unit='203' price={renderPrice(data['531-203'], matrixType)} status={data['531-203'].status}/>
                        <EmptyCell />
                        <Cell unit='204' price={renderPrice(data['531-204'], matrixType)} status={data['531-204'].status}/>
                        <Cell unit='205' price={renderPrice(data['531-205'], matrixType)} status={data['531-205'].status}/>
                        <Cell unit='206' price={renderPrice(data['531-206'], matrixType)} status={data['531-206'].status}/>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell content='1FL' />
                        <Cell unit='101' price={renderPrice(data['531-101'], matrixType)} status={data['531-101'].status}/>
                        <Cell unit='102' price={renderPrice(data['531-102'], matrixType)} status={data['531-102'].status}/>
                        <Cell unit='103' price={renderPrice(data['531-103'], matrixType)} status={data['531-103'].status}/>
                        <EmptyCell />
                        <Cell unit='104' price={renderPrice(data['531-104'], matrixType)} status={data['531-104'].status}/>
                        <EmptyCell />
                        <Cell unit='105' price={renderPrice(data['531-105'], matrixType)} status={data['531-105'].status}/>
                        <Cell unit='106' price={renderPrice(data['531-106'], matrixType)} status={data['531-106'].status}/>
                    </Table.Row>

                    <Table.Row>
                        <Table.Cell content='Total' />
                        <Table.Cell />
                        <Table.Cell style={styles.yellow}>${countTotal(['531-301', '531-201', '531-101'])}</Table.Cell>
                        <Table.Cell />
                        <Table.Cell style={styles.yellow}>${countTotal(['531-302', '531-202', '531-102'])}</Table.Cell>
                        <Table.Cell />
                        <Table.Cell style={styles.yellow}>${countTotal(['531-103'])}</Table.Cell>
                        <Table.Cell />
                        <Table.Cell style={styles.yellow}>${countTotal(['531-303', '531-203'])}</Table.Cell>
                        <Table.Cell />
                        <Table.Cell style={styles.yellow}>${countTotal(['531-104'])}</Table.Cell>
                        <Table.Cell />
                        <Table.Cell style={styles.yellow}>${countTotal(['531-304', '531-204'])}</Table.Cell>
                        <Table.Cell />
                        <Table.Cell style={styles.yellow}>${countTotal(['531-305', '531-205', '531-105'])}</Table.Cell>
                        <Table.Cell />
                        <Table.Cell style={styles.yellow}>${countTotal(['531-306', '531-206', '531-106'])}</Table.Cell>

                    </Table.Row>
                </Table.Body>
            </Table>
        </div>
    );
};

export default MiamiBayMatrix;
